<template>
  <div class="control-list" :class="{ 'control-list-show': isShow }">
    <div class="blur-bg map-blur-panel"></div>
    <div class="control-list-panel flex-valign">
      <!-- 布控搜索条件 -->
      <div class="list-search map-blur-panel__title flex-right valign-center">
        <!-- 类型条件 -->
        <!-- <div
          class="text-center flex-auto pointer"
          v-if="searchForm.isGroup === '1'"
        >
          <div
            @click.stop="
              typeExpandType = !typeExpandType;
              statusExpandType = searchFormShow = false;
            "
            class="flex-center valign-center"
          >
            <div class="mr5 ell flex-auto">
              <span>{{ typeMap[searchForm.controlType] }}</span>
              <span v-if="searchForm.controlType === 0">类型</span>
            </div>
            <span
              :class="[
                'iconfont-lunan icon-lunan-xiaosanjiaodown',
                typeExpandType ? 'icon-transform' : '',
                'select-arrow'
              ]"
            ></span>
          </div>
          <div :class="['type-select', typeExpandType ? 'expand' : '']">
            <el-scrollbar class="select-area flex-valign">
              <div
                class="type-option flex-auto valign-center"
                :class="item.value === searchForm.controlType ? 'choosed' : ''"
                v-for="(item, index) in controlTypeList"
                :key="index"
                @click.stop="chooseType(index, 'controlType', 'typeExpandType')"
              >
                {{ item.label }}
              </div>
            </el-scrollbar>
          </div>
        </div> -->
        <!-- 状态条件 -->
        <!-- <div
          class="text-center flex-auto pointer"
          v-if="searchForm.isGroup === '1'"
        >
          <div
            @click.stop="
              statusExpandType = !statusExpandType;
              typeExpandType = searchFormShow = false;
            "
            class="flex-center valign-center"
          >
            <div class="mr5 ell flex-auto">
              <span>{{ statusMap[searchForm.status] }}</span>
              <span v-if="searchForm.status === '0'">状态</span>
            </div>
            <span
              :class="[
                'iconfont-lunan icon-lunan-xiaosanjiaodown',
                statusExpandType ? 'icon-transform' : '',
                'select-arrow'
              ]"
            ></span>
          </div>
          <div :class="['type-select', statusExpandType ? 'expand' : '']">
            <el-scrollbar class="select-area flex-valign">
              <div
                class="type-option flex-auto valign-center"
                :class="item.value === searchForm.status ? 'choosed' : ''"
                v-for="(item, index) in statusList"
                :key="index"
                @click.stop="chooseType(index, 'status', 'statusExpandType')"
              >
                {{ item.label }}
              </div>
            </el-scrollbar>
          </div>
        </div> -->
        <!-- 更多 -->
        <div class="point-icon iconfont-lunan icon-lunan-gengduoda ml10" :style="{
          color: searchFormShow ? '#fff' : '',
        }" style="margin-right: 5px" @click.stop="() => {
  searchFormShow = !searchFormShow;
  statusExpandType = typeExpandType = false;
}
  "></div>
        <el-collapse-transition>
          <div class="list-search_form" v-if="searchFormShow" @click.stop="stopPropagation">
            <el-form :model="searchForm" label-width="100px">
              <el-form-item label="任务名称：" v-if="searchForm.isGroup === '1'">
                <el-input v-model="searchForm.controlName" @click.stop.native="stopPropagation" placeholder="请输入任务名称"
                  class=""></el-input>
              </el-form-item>
              <el-form-item label="设备名称：" v-if="searchForm.isGroup === '1'">
                <el-input clearable v-model="searchForm.deviceName" @click.stop.native="stopPropagation"
                  placeholder="请输入设备名称" class=""></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="reset">重置</el-button>
                <el-button type="primary" @click="queryList">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>
      <!-- 布控列表 -->
      <div v-show="!planList.length" class="text-center flex-auto no-data flex-valign">
        <div class="text-center">
          <img src="@/common/assets/images/empty.svg" class="no-data_img" />
        </div>
        <span>暂无数据</span>
      </div>
      <!-- 逐条展示列表 -->
      <div class="box-card flex-auto flex-valign" v-show="planList.length && searchForm.isGroup === '1'">
        <el-scrollbar class="full-height full-width">
          <div v-for="item in planList" :key="item.id" :class="activeInfo && item.controlCode == activeInfo.controlCode
            ? 'active'
            : ''
            " class="box-card_item map-blur-panel__list-item pointer" @click="planListDetail(item)">
            <div class="item-title">
              <el-tooltip placement="top-start" :content="item.controlName">
                <div class="control-list_tab">
                  <span class="control-list_name">{{ item.controlName }}</span>
                </div>
              </el-tooltip>
              <div>
                <el-tooltip effect="dark" content="编辑" placement="top-start" :visible-arrow="false">
                  <span style="margin: 0 16px" class="icon iconfont icon-xiugai" v-auth="'/controlManage/task:update'"
                    @click.stop="showEditPanel(item)"></span>
                </el-tooltip>

                <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
                  <span class="icon iconfont icon-shanchu" v-auth="'/controlManage/task:delete'"
                    @click.stop="deleteOne(item)"></span>
                </el-tooltip>
              </div>
            </div>
            <!-- 摄像机 -->
            <div class="f12 iconfont-lunan icon-lunan-shexiangji valign-center">
              <span class="m5">{{ item.deviceName }}【{{ item.repositoriesName }}】</span>
            </div>
            <!-- 时间 -->
            <div class="iconfont-lunan icon-lunan-clock f12 mt5">
              <span class="list-planTime ml5">{{ item.createTime }}</span>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <!-- 分页器 -->
      <div class="data-pagination map-blur-panel__title">
        <el-pagination small layout="total, prev, pager, next" :page-size="searchForm.pageSize" :total="total"
          :current-page="searchForm.pageNum" :pager-count="5" @current-change="pageChange" @prev-click="pageChange"
          @next-click="pageChange"></el-pagination>
      </div>
      <!-- 面板拉手 -->
      <div class="control-list-toolbar valign-center">
        <div v-show="!isShow" class="
            map-blur-panel__expand-button
            left
            iconfont-lunan
            icon-lunan-shousuocaidan-copy
          " @click="showPlanListPanel"></div>
        <div v-show="isShow" class="
            map-blur-panel__expand-button
            left
            iconfont-lunan
            icon-lunan-shousuocaidan
          " @click="showPlanListPanel"></div>
      </div>
    </div>
    <!-- 新增btn -->
    <div v-if="showAdd">
      <el-button class="add-btn" v-auth="'/controlManage/task:add'" type="primary" @click="createTask">创建布控任务</el-button>
    </div>
  </div>
</template>
<script>
import { api } from "../api";
import utils from "@src/common/utils";
import { Dic } from "$utils";
export default {
  name: "control-left-car",
  watch: {
    "searchForm.controlName"(newValue, oldValue) {
      this.searchForm.pageNum = 1;
    },
    "searchForm.controlGroupName"(newValue, oldValue) {
      this.searchForm.pageNum = 1;
    },
    "searchForm.deviceName"(newValue, oldValue) {
      this.searchForm.pageNum = 1;
    },
  },
  data() {
    return {
      showAdd: true,
      isShow: false,
      expandType: true,
      searchForm: {
        controlType: "2",
        controlGroupType: 0,
        status: "0",
        controlName: "",
        deviceName: "",
        isGroup: "1",
        pageNum: 1,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      searchFormShow: false,
      planList: [],
      planGroupList: [],
      controlTypeList: Dic.find("SENU081"),
      controlGroupTypeList: Dic.find("SENU081"),
      typeMap: {},
      typeExpandType: false,
      statusList: [
        {
          label: "全部",
          value: "0",
        },
        {
          label: "启用",
          value: "1",
        },
        {
          label: "停用",
          value: "2",
        },
      ],
      statusExpandType: false,
      status: 1,
      statusMap: {
        0: "全部",
        1: "启用",
        2: "停用",
      },
      activeInfo: null,
      total: 0,
      pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      currentPage: 1,
    };
  },
  mounted() {
    this.isShow = true;
    document.addEventListener("click", this.domClick);
    this.controlTypeList.forEach((item) => {
      this.typeMap[item.value] = item.label;
    });
    this.queryList();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.domClick);
  },
  methods: {
    showPlanListPanel() {
      this.isShow = !this.isShow;
    },
    createTask() {
      this.showAdd = false;
      this.$emit("createTask");
    },
    showEditPanel(item) {
      this.activeInfo = { ...item };
      this.$emit("editTask", item);
    },
    stopPropagation() {
      // 阻止冒泡
    },
    domClick() {
      this.typeExpandType = false;
      this.statusExpandType = false;
      this.searchFormShow = false;
    },
    chooseType(index, label, expandType) {
      this.searchForm[label] = this[label + "List"][index].value;
      this[expandType] = false;
      this.queryList();
    },
    pageChange(pageNum) {
      this.searchForm.pageNum = pageNum;
      this.queryList();
    },
    queryList() {
      if (this.searchForm.isGroup === "1") {
        this.$fetch(api.queryControlTask, this.searchForm).then((res) => {
          if (res.success) {
            if (res.returnObj.list) {
              this.planList = res.returnObj.list;
              this.total = res.returnObj.total;
            }
          } else {
            this.$message.error(res.msgContent);
          }
        });
      } else {
        delete this.searchForm.deviceName;
        this.$fetch(api.queryControlGroupTask, this.searchForm).then((res) => {
          if (res.success) {
            if (res.returnObj.list) {
              this.planGroupList = res.returnObj.list.map((item) => {
                this.$set(item, "isExpand", false);
                return item;
              });
              this.total = res.returnObj.total;
            }
          } else {
            this.$message.error(res.msgContent);
          }
        });
      }
    },
    planListDetail(row) {
      this.$fetch(api.queryControlTaskDetail, {
        controlCode: row.controlCode,
      }).then((res) => {
        if (res.success) {
          const detailInfo = res.returnObj;
          this.showAdd = false;
          this.activeInfo = { ...row };
          this.$emit("openDetail", detailInfo);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    reset() {
      this.searchForm = {
        controlType: "2",
        status: "0",
        isGroup: "1",
        controlName: "",
        controlGroupName: "",
        deviceName: "",
        pageNum: 1,
        pageSize: 10,
      };
      this.queryList();
    },
    deleteOne(row) {
      this.$confirm("是否删除此任务?", "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const params = {
          controlCodeList: [row.controlCode],
          controlType: row.controlType,
        };
        this.$fetch(api.deleteControlTask, params).then((res) => {
          if (res.success) {
            this.$message.success("删除成功");
            this.queryList();
            this.$emit("deleteList");
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
  },
};
</script>
<style lang="scss">
@import "../style/control-left.scss";
</style>
